import { ContentCourse, Question } from "../schemas/schemas";
import { courseContentMockService } from "../../../../lib/mockData/courseContentMockService";

export interface ImportCourseRequest {
  file: File;
  options?: {
    overwrite?: boolean;
    validateOnly?: boolean;
  };
}

// Main service - directly calls mock service
export const courseContentService = {
  getCourse: async (courseId: string): Promise<ContentCourse> => {
    return courseContentMockService.getCourse(courseId);
  },

  getCourses: async (): Promise<ContentCourse[]> => {
    return courseContentMockService.getCourses();
  },

  createCourse: async (courseData: Partial<ContentCourse>): Promise<ContentCourse> => {
    return courseContentMockService.createCourse(courseData);
  },

  updateCourse: async (courseId: string, courseData: Partial<ContentCourse>): Promise<ContentCourse> => {
    return courseContentMockService.updateCourse(courseId, courseData);
  },

  deleteCourse: async (courseId: string): Promise<void> => {
    return courseContentMockService.deleteCourse(courseId);
  },

  importCourse: async (request: ImportCourseRequest): Promise<ContentCourse> => {
    return courseContentMockService.importCourse(request);
  },

  getQuestionBank: async (): Promise<Question[]> => {
    return courseContentMockService.getQuestionBank();
  },
}; 